import React, { useState } from "react";

import { Icon } from "../../shared/Icon/Icon";

import "../CalendarError/CalendarError.scss";

const TROUBLESHOOTING_URL =
  "https://support.gogetcorp.com/hc/en-us/articles/6820462050972-Troubleshooting-Microsoft-365-integration#h_01KZ8MVFAMFS91334BDP79BHCT";

export const MicrosoftRoomCalendarNotice = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <div
      className="CalendarError CalendarError--info d-flex mb-3"
      role="status"
    >
      <div className="d-flex gap-1">
        <Icon icon="red-error-icon" />

        <div className="d-flex flex-column CalendarError__content">
          <p>
            Due to a previous issue in the Microsoft 365 Graph API, newly shared
            room calendars (created after approximately <strong>July 20</strong>
            ) may not automatically appear for the service account.
            {!isExpanded && (
              <button
                type="button"
                className="CalendarError__content--expand ml-1"
                onClick={() => setIsExpanded(true)}
                aria-expanded={false}
              >
                Expand
              </button>
            )}
          </p>

          {isExpanded && (
            <>
              <p>
                Previously shared room calendars continue to work as expected.
              </p>
              <p>
                Although Microsoft has indicated that the issue has been
                resolved, some environments may still experience
                inconsistencies. Therefore, if your room calendars were created
                after approximately July 20 and are not listed automatically, we
                recommend following the{" "}
                <a
                  href={TROUBLESHOOTING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  troubleshooting steps to remove and re-share the room
                  calendars
                </a>
                .
              </p>
              <button
                type="button"
                className="CalendarError__content--expand"
                onClick={() => setIsExpanded(false)}
                aria-expanded={true}
              >
                Hide
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
